import React from "react";
import { Types, Enums } from "@sendum/core";

// TODO =>
export const calculateAlarmDescription = (item: Types.Pallet): string => {
	let torDescription: string | undefined = undefined;
	let cpdDescription: string | undefined = undefined;

	if (item.Tor >= item.Product.TorAlarmThreshold) {
		torDescription = "TOR Alarm";
	}

	if (item.Tor >= item.Product.TorWarningThreshold && item.Tor < item.Product.TorAlarmThreshold) {
		torDescription = "TOR Warning";
	}

	if (item.Cpd >= item.Product.CpdAlarmThreshold) {
		cpdDescription = "CPD Alarm";
	}

	if (item.Cpd >= item.Product.CpdWarningThreshold && item.Tor < item.Product.CpdAlarmThreshold) {
		cpdDescription = "CPD Warning";
	}

	return `${torDescription ?? ""}${!!torDescription && !!cpdDescription ? ", " : ""} ${cpdDescription ?? ""}`.trim();
};

export const renderTime = (className: string, time: number, label: string): JSX.Element | null => {
	if (!time) {
		return (
			<div className={className}>
				<p>{label}</p>
				<div>0:00</div>
			</div>
		);
	}

	if (time / 60 > 999) {
		return (
			<div className={className}>
				<p>{label}</p>
				<div> +999h</div>
			</div>
		);
	}

	const h = Math.trunc(time / 60);
	const m = time - h * 60;

	return (
		<div className={className}>
			<p>{label}</p>
			<div>{h}:{m < 10 ? `0${m}` : m}</div>
		</div>
	);
};

export const sortPallets = (a: Types.Pallet, b: Types.Pallet): number => {
	const aS = a.CurrentState === Enums.PalletState.Alarm ? 0 : (a.CurrentState === Enums.PalletState.Warning ? 1 : 2);
	const bS = b.CurrentState === Enums.PalletState.Alarm ? 0 : (b.CurrentState === Enums.PalletState.Warning ? 1 : 2);
	const aB = a.Batch.BatchNumber.toLowerCase();
	const bB = b.Batch.BatchNumber.toLowerCase();
	const aP = a.PalletNumber ? +a.PalletNumber : 0;
	const bP = b?.PalletNumber ? +b.PalletNumber : 0;

	return aS - bS || aB.localeCompare(bB) || aP - bP;
};
